// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { INITIALIZE_KYC_METHOD_CONFIGURATION } from './constants/kyc-landing.service.constants';
// Types
import { IdentificationApiResponseType } from 'types/identification-api-response.type';
import { KycContextType } from 'containers/kyc/contexts/types/kyc.context.type';

const initializeKycMethodService = async (
  method: KycContextType['selectedMethod']
): Promise<[IdentificationApiResponseType, Response]> =>
  apiUtils.post({
    ...INITIALIZE_KYC_METHOD_CONFIGURATION,
    params: { identificationType: method },
  });

export { initializeKycMethodService };
